import { PaymentProcessAPI as o } from "../paymentProcess.js";
class i extends o.PaymentProcess {
  constructor(e) {
    super({
      ...e
    });
  }
  afterInitialize(e) {
    return Promise.resolve();
  }
  updateEngineAmount(e) {
  }
  mount(e) {
    return Promise.resolve();
  }
  initialize() {
    return Promise.resolve();
  }
  async executePayment(e) {
    return await this.paymentRepository.process({
      orderId: e.orderId,
      amount: this.configuration.amount,
      tip: this.configuration.tip,
      cashback: this.configuration.cashback,
      shopUrl: e.shopUrl,
      email: e.email,
      externalUserId: e.externalUserId,
      wsUuid: e.wsUuid,
      currency: this.configuration.currency,
      actions: e.actions,
      locationId: this.configuration.locationId,
      selectedItems: e.selectedItems,
      loyaltyId: e.loyaltyId,
      paymentMethods: [{
        engine: this.configuration.engine,
        methodType: this.configuration.method
      }],
      storePaymentMethod: e.storePaymentMethod,
      countryCode: this.configuration.countryCode,
      shopOrderSource: this.configuration.shopOrderSource
    });
  }
}
export {
  i as DummyPaymentProcess
};
//# sourceMappingURL=dummy.process.js.map
